import React, { Component, createRef } from 'react'
import { Element } from 'react-scroll'
import { connect } from 'react-redux'
import { Card, CardTitle } from 'react-toolbox/lib/card'
import { Flex } from 'reflexbox'
import CSSModules from 'helpers/CSSModulesUtil'

import T from 'i18n-react'
import Dialog from 'react-toolbox/lib/dialog'

import Collapse from './Collapse'
import Divider from './Divider'
import MultiSelectDropdownHoc from 'containers/Form/MultiSelectDropdown/index'
import DropdownTypeaheadHoc from 'containers/Form/SingleSelectDropdownTypeahead/index'
import MultiSelectDropdownCreatableHoc from 'containers/Form/MultiSelectDropdownCreatable/index'
import SingleSelectDropdownCreatableHoc from 'containers/Form/SingleSelectDropdownCreatable/index'
import DropdownHoc from 'containers/Form/Dropdown/index'
import SliderHoc from 'containers/Form/Slider/index'
import RiskSliderHoc from 'containers/Form/RiskSlider/index'
import RiskIntegerSliderHoc from 'containers/Form/RiskIntegerSlider/index'
import RiskTwoDecimalSliderHoc from 'containers/Form/RiskTwoDecimalSlider/index'
import IntegerSlider from 'containers/Form/IntegerSlider/index'
import RiskHoc from 'containers/Form/RiskValidation/index'
import InputHoc from 'containers/Form/Input/index'
import IntegerInputHoc from 'containers/Form/IntegerInput/index'
import TwoDecimalInputHoc from 'containers/Form/TwoDecimalInput/index'
import MultiHexInputHoc from 'containers/Form/MultiHexInput/index'
import HexInputHoc from 'containers/Form/HexInput/index'
import NumberInputHoc from 'containers/Form/NumberInput/index'
import DesktopScheduleHoc from 'containers/Form/DesktopSchedule/index'
import NotebookScheduleHoc from 'containers/Form/NotebookSchedule/index'
import ColorDropdownHoc from 'containers/Form/ColorDropdown/index'
import ClockHoc from 'containers/Form/Clock/index'
import PcbLayerCountHoc from 'containers/Form/PcbLayerCount/index'
import InputConnectorHoc from 'containers/Form/InputConnector/index'
import DisplayConnectorHoc from 'containers/Form/DisplayConnector/index'
import MemoryHoc from 'containers/Form/Memory/index'
import NotebookDisplayConnectorHoc from 'containers/Form/NotebookDisplayConnector/index'
import NotebookVoltageRegulatorHoc from 'containers/Form/NotebookPowerSupply/VoltageRegulators/index'
import NotebookPowerComponentsHoc from 'containers/Form/NotebookPowerSupply/PowerComponents/index'
import NotebookPanelHoc from 'containers/Form/NotebookPanel/index'
import NotebookCpuHoc from 'containers/Form/NotebookCpu/index'
import SelectedCpuHoc from 'containers/Form/SelectedCpu/index'
import FeatureHoc from 'containers/Form/Feature/index'
import RestrictedHoc from 'containers/Form/Restricted/index'
import ProjectNameHoc from 'containers/Form/ProjectNameInput/index'
import PowerMonitorIcHoc from 'containers/Form/PowerMonitorIc/index'
import NicHoc from 'containers/Form/Nic/index.jsx'
import BaseboardPowerComponentsHoc from 'containers/Form/BaseboardPowerComponents/index'
import PcieSwitchRetimerHoc from 'containers/Form/PcieSwitchRetimer/index.jsx'
import VerticalTableInputHoc from 'containers/Form/VerticalTableInput/index'
import HorizontalTableInput from 'containers/Form/HorizontalTableInput/index'
import ProductStorageHoc from 'containers/Form/ProductStorage/index.jsx'
import MissionProfileHoc from 'containers/Form/MissionProfile'
import MultiFieldSimpleHoc from 'containers/Form/MultiFieldSimple/index.jsx'
import CheckboxHoc from 'containers/Form/Checkbox/index.jsx'
import MenuButton from '../../../components/fulcrum/button/MenuButton'
import ScheduleEdit from 'containers/Project/ScheduleSection/ScheduleEdit'
import {
  categoryElementsSelector, importDialogActiveSelector,
} from './selectors'
import {
  formattedFormElementsSelector,
} from 'containers/Form/selectors'
import {
  clearValidation,
} from 'containers/Form/Validation/actions'
import {
  clearRisk,
} from 'containers/Form/RiskValidation/actions'

import {
  scrollTop
} from 'containers/Project/View/actions'
import {
  scrolledTop
} from 'containers/Project/View/selectors'
import {
  setImportDialogActive
} from './actions'
import ProjectImportDialog from 'containers/Form/ProjectImportDialog'
import EditHeader from 'containers/Project/Header/EditHeader'

import styles from './styles.scss'
import { collapseSelector } from 'containers/Project/Header/selectors'
import { setSticky } from 'containers/Project/Header/actions'
import { Button } from 'react-toolbox/lib/button'
import notifyHoc from 'containers/App/Notification/Notify'
import { compose, nest } from 'recompose'
import sagas from './sagas'
import injectSagas from 'helpers/injectSagas'
import { MODULE_NAME } from './constants'
const InfoButton = notifyHoc(Button)

const mapStateToProps = (state) => {
  return {
    categories: categoryElementsSelector(state),
    elements: formattedFormElementsSelector(state),
    scrolledTop: scrolledTop(state),
    collapse: collapseSelector(state),
    form: state.form,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearValidationChecks: () => {
      dispatch(clearRisk())
      dispatch(clearValidation())
    },
    scrollTopAction: (isTop) => dispatch(scrollTop(isTop)),
    setSticky: (sticky) => dispatch(setSticky(sticky)),
    setImportDialogActive: () => dispatch(setImportDialogActive()),
  }
}

class ProjectForm extends Component {
  static pathName = 'form'
  
  constructor(props) {
    super(props);
    this.scrollDivRef = createRef();
  }

  componentWillMount() {
    this.props.clearValidationChecks()
  }

  shouldComponentUpdate(nextProps) {
    if (Object.keys(nextProps.form).length === Object.keys(this.props.form).length)
      return false
    return true
  }

  // Generates the form components grouped by the category type.
  generateCategoryContainers(){
    const { categories, elements } = this.props
    const lastCategoryIndex = categories.length - 1
    return categories.map(({category, elementIds}) => {
      const components = elementIds.map(id => elements[id])
      return (
        <Element name={category} key={category} className="element">
          <Collapse label={category}>
            { this.generateFormComponents(components) }
          </Collapse>
       </Element>
      )
    }).reduce((containers, container, index, array) => {
      const result = [...containers, container]
      const isLastCategory = (index === lastCategoryIndex)
      return (isLastCategory) ? result : [...result, <Divider key={`divider_${index}`}/>]
    }, [])
  }

  generate(hocComponent) {
    return (id, validation) => {
      const Component = hocComponent(ProjectForm.pathName, id, validation)
      return <Component key={id}/>
    }
  }

  generateFormComponents(components) {
    return components.map(component => {
      const {
        id,
        uiType,
        validation
      } = component
      // console.log(component)
      switch(uiType) {
      case 'drop_down': return this.generate(DropdownHoc)(id, validation)
      case 'checkbox_list': return this.generate(CheckboxHoc)(id, validation)
      case 'drop_down_typeahead': return this.generate(DropdownTypeaheadHoc)(id, validation)
      case 'drop_down_creatable': return this.generate(SingleSelectDropdownCreatableHoc)(id, validation)
      case 'multi_select_drop_down': return this.generate(MultiSelectDropdownHoc)(id, validation)
      case 'multi_select_drop_down_creatable': return this.generate(MultiSelectDropdownCreatableHoc)(id, validation)
      case 'slider': return this.generate(SliderHoc)(id, validation)
      case 'project_type': return this.generate(RiskHoc)(id, validation)
      case 'risk_slider': return this.generate(RiskSliderHoc)(id, validation)
      case 'risk_integer_slider': return this.generate(RiskIntegerSliderHoc)(id, validation)
      case 'risk_two_decimal_slider': return this.generate(RiskTwoDecimalSliderHoc)(id, validation)
      case 'integer_slider': return this.generate(IntegerSlider)(id, validation)
      case 'text': return this.generate(InputHoc)(id, validation)
      case 'integer_input': return this.generate(IntegerInputHoc)(id, validation)
      case 'two_decimal_input': return this.generate(TwoDecimalInputHoc)(id, validation)
      case 'hex_text': return this.generate(HexInputHoc)(id, validation)
      case 'number_text': return this.generate(NumberInputHoc)(id, validation)
      case 'desktop_schedule': return this.generate(DesktopScheduleHoc)(id, validation)
      case 'notebook_schedule': return this.generate(NotebookScheduleHoc)(id, validation)
      case 'color_drop_down': return this.generate(ColorDropdownHoc)(id, validation)
      case 'clock': return this.generate(ClockHoc)(id, validation)
      case 'pcb_layer_count': return this.generate(PcbLayerCountHoc)(id, validation)
      case 'input_connector': return this.generate(InputConnectorHoc)(id, validation)
      case 'desktop_display_connector': return this.generate(DisplayConnectorHoc)(id, validation)
      case 'notebook_display_connector': return this.generate(NotebookDisplayConnectorHoc)(id, validation)
      case 'svid': return this.generate(MultiHexInputHoc)(id, validation)
      case 'ssid': return this.generate(MultiHexInputHoc)(id, validation)
      case 'memory': return this.generate(MemoryHoc)(id, validation)
      case 'notebook_voltage_regulator': return this.generate(NotebookVoltageRegulatorHoc)(id, validation)
      case 'notebook_power_components': return this.generate(NotebookPowerComponentsHoc)(id, validation)
      case 'desktop_voltage_regulator': return this.generate(NotebookVoltageRegulatorHoc)(id, validation)
      case 'notebook_panel': return this.generate(NotebookPanelHoc)(id, validation)
      case 'cpu': return this.generate(NotebookCpuHoc)(id, validation)
      case 'selected_cpu': return this.generate(SelectedCpuHoc)(id, validation) 
      case 'feature': return this.generate(FeatureHoc)(id, validation)
      case 'restricted': return this.generate(RestrictedHoc)(id, validation)
      case 'project_name': return this.generate(ProjectNameHoc)(id, validation)
      case 'power_monitor_ic': return this.generate(PowerMonitorIcHoc)(id, validation)
      case 'nic': return this.generate(NicHoc)(id, validation)
      case 'baseboard_power_components': return this.generate(BaseboardPowerComponentsHoc)(id, validation)
      case 'pcie_switch_retimer': return this.generate(PcieSwitchRetimerHoc)(id, validation)
      case 'memory_storage_device': return this.generate(HorizontalTableInput)(id, validation)
      case 'high_current_device': return this.generate(VerticalTableInputHoc)(id, validation)
      case 'lc_voltage_regulator_device': return this.generate(VerticalTableInputHoc)(id, validation)
      case 'fsi_interface': return this.generate(HorizontalTableInput)(id, validation)
      case 'peripheral_interface_spi': return this.generate(HorizontalTableInput)(id, validation)
      case 'peripheral_interfaces_i_2_c': return this.generate(HorizontalTableInput)(id, validation)
      case 'fsync_signal': return this.generate(VerticalTableInputHoc)(id, validation)
      case 'pwm': return this.generate(VerticalTableInputHoc)(id, validation)
      case 'uart': return this.generate(VerticalTableInputHoc)(id, validation)
      case 'peripheral_interfaces_dap': return this.generate(HorizontalTableInput)(id, validation)
      case 'peripheral_interfaces_can': return this.generate(VerticalTableInputHoc)(id, validation)
      case 'peripheral_interfaces_eth': return this.generate(HorizontalTableInput)(id, validation)
      case 'peripheral_interfaces_usb_2': return this.generate(HorizontalTableInput)(id, validation)
      case 'peripheral_interfaces_usb_3': return this.generate(HorizontalTableInput)(id, validation)
      case 'camera_video_input': return this.generate(HorizontalTableInput)(id, validation)
      case 'system_saftey_mcu': return this.generate(HorizontalTableInput)(id, validation)
      case 'peripheral_interfaces_pcie': return this.generate(HorizontalTableInput)(id, validation)
      case 'display_hdmi': return this.generate(HorizontalTableInput)(id, validation)
      case 'system_ethernet_switch': return this.generate(HorizontalTableInput)(id, validation)
      case 'thermal_interface_material_detail': return this.generate(VerticalTableInputHoc)(id, validation)
      case 'product_storage': return this.generate(ProductStorageHoc)(id, validation)
      case 'mission_profile': return this.generate(MissionProfileHoc)(id, validation)
      case 'cpu_root_port': return this.generate(VerticalTableInputHoc)(id, validation)
      case 'mgx_bay_type': return this.generate(VerticalTableInputHoc)(id, validation)
      case 'multi_field_simple': return this.generate(MultiFieldSimpleHoc)(id, validation)
      default: return <div key={id}/>
      }
    })
  }

  generateAdditionalCards(){
    const { isNewProject, segment } = this.props
    if(isNewProject){
      return (
        <Element name='Schedule'>
          <Card theme={styles} styleName='additionalCard'>
            <CardTitle theme={styles} title='Schedule'/>
            <Divider className={styles.additionalCardTitleDivider}/>
            <ScheduleEdit onCreate segment={segment}/>
          </Card>
        </Element>
      )
    }
    return
  }

  
  onScroll = (e) => {
    const {
      scrolledTop,
      scrollTopAction,
      collapse,
      setSticky,
    } = this.props
    const top = Math.floor(e.target.scrollTop) < this.scrollDivRef.current.offsetTop

    if (top === scrolledTop) return
    if (collapse !== top) setSticky(collapse)
    scrollTopAction(top)  
  }

  render() {

    const {
      update,
      isNewProject,
      projectId,
      productSku,
      productBrand,
      gpuSku,
      segment,
      partnerSite,
      isRisk,
      setImportDialogActive,
    } = this.props

    return (
      <Flex column styleName='flexWrapper' id='mainContainer' onScroll={this.onScroll}>
        <EditHeader
          update={update}
          id={projectId}
          sku={productSku}
          brand={productBrand}
          gpuSku={gpuSku}
          segment={segment}
          partnerSiteName={partnerSite}
          risk={isRisk}
        />
        <div ref={this.scrollDivRef} key={this.props}/>
        <Card theme={styles} styleName='specificationCard'>
          <Flex styleName="specTitle">
            <CardTitle theme={styles} title='Specification'/>
            <InfoButton
              styleName="button"
              icon='copy_all'
              label={'Import'}
              message={T.translate('pages.project.view.notification.import_project')}
              onClick={setImportDialogActive}
              raised
              primary
            />
          </Flex>
          { this.generateCategoryContainers() }
        </Card>
        { this.generateAdditionalCards() }
        <ProjectImportDialog />
      </Flex>
    )
  }
}


const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)
const withSagas = injectSagas({ [MODULE_NAME]: sagas })

export default compose(
  withSagas,
  withConnect,
  withStyle,
)(ProjectForm)
